
import React from 'react';

const Footer = () => {
  return (
    <div className='footer'>
    <footer class="footer-section">
      <p class="copyright">
        &copy; 2023 Made with ❤️ by Shreyas
      </p>
    </footer>
    </div>
  );
};

export default Footer;
